export default __webpack_public_path__ + "static/testi-4-d7061d9be48dfbaed8c9b315c8eeaec8.png";